// extracted by mini-css-extract-plugin
export default {"header":"header__o6wdS","close":"close__HJmC9"};